import React, { useState, useEffect } from "react";
import "./App.css";
import PasswordGenerator from "./components/PasswordGenerator";
import SrtUploader from "./components/SrtUploader";
import { parseSRT } from "./utils/srtParser";
import { SubtitleEntry } from "./types";

function App() {
  const [subtitles, setSubtitles] = useState<SubtitleEntry[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [useDefaultSrt, setUseDefaultSrt] = useState<boolean>(true);

  useEffect(() => {
    // Only load the default SRT if we're using it and don't have subtitles yet
    if (useDefaultSrt && subtitles.length === 0) {
      setIsLoading(true);
      // Load and parse the default SRT file
      fetch("/assets/BeeMovieSubs.srt")
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to load SRT file");
          }
          return response.text();
        })
        .then((srtData) => {
          const parsedSubtitles = parseSRT(srtData);
          setSubtitles(parsedSubtitles);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("Error loading SRT file:", err);
          setError(err.message);
          setIsLoading(false);
        });
    }
  }, [useDefaultSrt, subtitles.length]);

  const handleSrtUploaded = (newSubtitles: SubtitleEntry[]) => {
    setSubtitles(newSubtitles);
    setUseDefaultSrt(false);
    setError(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Quotable Passwords</h1>
        <p>
          Generate memorable passwords based on lines from movies, or tv shows,
          or 4 hour long hbomberguy video essays, your choice!
        </p>
      </header>
      <main>
        <SrtUploader onSrtLoaded={handleSrtUploaded} />

        <div className="divider">
          <span>
            {useDefaultSrt
              ? "Using default Bee Movie SRT"
              : "Using your uploaded SRT"}
          </span>
        </div>

        {isLoading ? (
          <p>Loading subtitles...</p>
        ) : error ? (
          <div className="error-container">
            <p>Error: {error}</p>
            <button
              className="retry-btn"
              onClick={() => setUseDefaultSrt(true)}
            >
              Try using default SRT
            </button>
          </div>
        ) : subtitles.length === 0 ? (
          <div className="no-srt-container">
            <p>
              No subtitle data available. Please upload an SRT file or use the
              default.
            </p>
            <button
              className="default-srt-btn"
              onClick={() => setUseDefaultSrt(true)}
            >
              Use default Bee Movie SRT
            </button>
          </div>
        ) : (
          <PasswordGenerator subtitles={subtitles} />
        )}
      </main>
      <footer>
        <p>© {new Date().getFullYear()} - For educational purposes only</p>
        <p>Default Bee Movie content is owned by DreamWorks Animation</p>
        <p>Please ensure you have the rights to use any uploaded content</p>
      </footer>
    </div>
  );
}

export default App;
